import React, { PureComponent } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Modal from 'components/Modal/Modal';
import DeviceVideo from 'components/DeviceVideo/DeviceVideo';
import { paddingBuilder } from 'styles/themeUtils';

import { ModalTriggerButton } from '../styles/ModalTriggerButton';
import { BlockHiddenOnMobile } from '../styles/BlockHiddenOnMobile';
import { StyledDeviceVideo } from '../styles/StyledDeviceVideo';

class SectionSimulate extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
  }

  handleToggleModal = () => {
    this.setState(state => ({ modalOpened: !state.modalOpened }));
  };

  render() {
    const videoId = 'o-hZOecd34M';
    const { modalOpened } = this.state;

    return (
      <Section
        backgroundColor="white.dark"
        id="emprestimo-pessoal"
      >
        <BlockHiddenOnMobile>
          <StyledDeviceVideo videoId={videoId} deviceType="dark" />
        </BlockHiddenOnMobile>
        <Block
          padding={{
            desktop: paddingBuilder.left(0),
          }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="LENDING.SIMULATE.TITLE"
            intlValues={{ br: <br /> }}
          />
          <Typography
            variant="paragraph2"
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="LENDING.SIMULATE.DESCRIPTION"
          />
          <ModalTriggerButton
            variant="basic"
            color="primary"
            onClick={this.handleToggleModal}
            id={videoId}
            intlKey="LENDING.SIMULATE.HOW_IT_WORKS"
          />
          <Modal
            isOpen={modalOpened}
            onModalClose={this.handleToggleModal}
            ariaId={videoId}
          >
            <DeviceVideo videoId={videoId} />
          </Modal>
        </Block>
      </Section>
    );
  }
}

export default SectionSimulate;
